module.exports = __webpack_public_path__ + "static/media/react.de655ba3.png";